import { render, staticRenderFns } from "./GameContent.vue?vue&type=template&id=4395f7c6&scoped=true&"
import script from "./GameContent.vue?vue&type=script&lang=js&"
export * from "./GameContent.vue?vue&type=script&lang=js&"
import style0 from "./GameContent.vue?vue&type=style&index=0&id=4395f7c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4395f7c6",
  null
  
)

export default component.exports